import { useParams, Navigate } from "react-router-dom";
import { useLoc } from "@/lib/queries";
import DistrictHub from "@/pages/DistrictHub";
import ServiceDistrict from "@/pages/ServiceDistrict";
import NotFound from "@/pages/NotFound";

export default function LocationResolver() {
  const { slug } = useParams();
  const { data, isLoading, isError } = useLoc(slug);

  if (isError) return <NotFound />;
  if (isLoading || !data) {
    return <div className="flex min-h-screen items-center justify-center text-neutral-500">Yükleniyor…</div>;
  }
  if (data.kind === "hub") return <DistrictHub data={data.data} />;
  if (data.kind === "service") return <ServiceDistrict data={data.data} />;
  if (data.kind === "redirect") return <Navigate to={data.data.to} replace />;
  return <NotFound />;
}
